import React from 'react'
import social from 'assets/stlswing/wednesday-night-swing.jpg'

export const WhatIsSwingDancingPanel = () => (
  <section className='overflow-hidden'>
    <div className='max-w-6xl px-4 mx-auto py-14 sm:px-6 md:py-20 md:grid md:grid-cols-12 md:gap-12 md:items-center'>
      <div className='md:col-span-6 lg:col-span-5'>
        <h2 className='h2 h2-lg'>What is swing dancing?</h2>
        <p className='mt-6 body'>
          Swing dancing is a way to meet new people, have fun, and get in shape.
          Just walk up to someone new, ask them to dance, and spend the next few
          minutes hopping and stomping your heart out to upbeat jazz music!
          Whether you want to have incredible experiences with people you just
          met, impress your friends at weddings, make art through movement, or
          compete against your peers, swing dancing will never let you down.
        </p>
      </div>

      {/* The photo runs off the right edge of the page on wide screens */}
      <img
        src={social}
        alt='A packed dance floor at Wednesday Night Swing, with the STL Swing logo projected on the wall'
        className='object-cover w-full mt-10 h-72 rounded-3xl md:mt-0 md:h-[28rem] md:col-span-6 lg:col-span-7 lg:w-[calc(100%+8rem)] lg:max-w-none'
      />
    </div>
  </section>
)
